import React from 'react';
import { useFusionAuth } from '@fusionauth/react-sdk';
import ConfigurableBaseExplorer from '../baseExplorer/ConfigurableBaseExplorer';
import ContextHelp from '../../../easymap/ContextHelp/ContextHelp';
import { createHotspotConfig } from './hotspotConfig';
import { HotspotEntity } from '../../../types/hotspot';

interface HotspotExplorerProps {
  className?: string;
  initialPosition?: { x: number; y: number };
  initialSize?: { width: number; height: number };
  onClose?: () => void;
  isWindowed?: boolean;
  windowTitle?: string;
  resizable?: boolean;
  draggable?: boolean;
}

const HotspotExplorer: React.FC<HotspotExplorerProps> = (props) => {
  const { isFetchingUserInfo, isLoggedIn } = useFusionAuth();

  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;
  const defaultPosition = isMobile ? { x: 5, y: 5 } : { x: 150, y: 120 };
  const defaultSize = isMobile
    ? { width: window.innerWidth - 10, height: window.innerHeight - 10 }
    : { width: 1200, height: 700 };

  const baseConfig = createHotspotConfig();

  if (isFetchingUserInfo) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Loading user context...</div>;
  }

  return (
    <ConfigurableBaseExplorer<HotspotEntity>
      key="hotspot-explorer"
      config={baseConfig}
      isAuthenticated={isLoggedIn}
      isWindowed={props.isWindowed ?? true}
      initialPosition={props.initialPosition ?? defaultPosition}
      initialSize={props.initialSize ?? defaultSize}
      resizable={props.resizable ?? true}
      draggable={props.draggable ?? true}
      showCloseButton={true}
      showMinimizeButton={true}
      windowTitle={props.windowTitle || 'Hotspot Explorer'}
      onWindowClose={props.onClose}
      className={`hotspot-explorer ${props.className || ''}`}
      customToolbar={<div className="hotspot-help-toolbar"><ContextHelp title='Help with Hotspot Data' context='hotspot-help' /></div>}
    />
  );
};

export default HotspotExplorer;
